(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('UsuariologDetailController', UsuariologDetailController);

    UsuariologDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Usuariolog'];

    function UsuariologDetailController($scope, $rootScope, $stateParams, previousState, entity, Usuariolog) {
        var vm = this;

        vm.usuariolog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:usuariologUpdate', function(event, result) {
            vm.usuariolog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
